import { isPermissionAllowed } from '../../../api/userPermissions';
import { documentToProductName } from '../../../utils/mappings';
import { getGlassboxLogger } from '../../../glassboxLogger';
const analyticsControlContextSelector = state => {
  var _state$userPermission;
  const viewLinkOwnPermission = (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.viewLink.own;
  if (isPermissionAllowed(viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : viewLinkOwnPermission.createWithAnalytics)) {
    return {
      disabled: false
    };
  } else {
    var _viewLinkOwnPermissio;
    return {
      disabled: true,
      paywall: {
        reason: 'notAllowedWithCurrentLicense',
        missingFeature: viewLinkOwnPermission === null || viewLinkOwnPermission === void 0 ? void 0 : (_viewLinkOwnPermissio = viewLinkOwnPermission.createWithAnalytics.missing_features) === null || _viewLinkOwnPermissio === void 0 ? void 0 : _viewLinkOwnPermissio.features[0],
        logger: () => getGlassboxLogger().logLoadedPaywallCta({
          cta_paywall_type: 'SECOND_VIEW_LINK',
          paywall_cta_product: documentToProductName(state.document.value)
        })
      }
    };
  }
};
export default analyticsControlContextSelector;